module.exports = __webpack_public_path__ + "img/coupons_icon.7f5b2064.svg";